<template>
  <BContainer
    class="p-0 py-2"
    fluid
  >
    <ValidationObserver
      ref="formInformation"
    >
      <form
        role="form"
        novalidate
        @submit.prevent
      >
        <BRow>

          <BCol
            cols="12"
            md="3"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="first_name"
              name="first name"
              rules="required"
            >
              <BFormGroup
                label="First Name"
                label-for="fFirstName"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormInput
                  id="fFirstName"
                  v-model="formInformation.first_name"
                  :placeholder="isVerified ? '' : 'enter first name here'"
                  :state="errors.length > 0 ? false : null"
                  :disabled="state.busy || isVerified"
                />
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="12"
            md="3"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="middle_name"
              name="middle name"
            >
              <BFormGroup
                label="Middle Name"
                label-for="fMiddleName"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormInput
                  id="fMiddleName"
                  v-model="formInformation.middle_name"
                  :placeholder="isVerified ? '' : 'enter middle name here'"
                  :state="errors.length > 0 ? false : null"
                  :disabled="state.busy || isVerified"
                />
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="12"
            md="3"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="last_name"
              name="last name"
              rules="required"
            >
              <BFormGroup
                label="Last Name"
                label-for="fLastName"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormInput
                  id="fLastName"
                  v-model="formInformation.last_name"
                  :placeholder="isVerified ? '' : 'enter last name here'"
                  :state="errors.length > 0 ? false : null"
                  :disabled="state.busy || isVerified"
                />
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="12"
            md="3"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="suffix_name"
              name="suffix name"
            >
              <BFormGroup
                label="Suffix Name"
                label-for="fSuffixName"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormInput
                  id="fSuffixName"
                  v-model="formInformation.suffix_name"
                  :placeholder="isVerified ? '' : 'enter suffix name here'"
                  :state="errors.length > 0 ? false : null"
                  :disabled="state.busy || isVerified"
                />
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="12"
            md="3"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="mobile_number"
              name="mobile number"
              rules="min:11|max:11|regex:[0]{1}[9]{1}[0-9]{8}"
            >
              <BFormGroup
                label="Mobile Number"
                label-for="fMobileNumber"
                label-class="font-weight-bolder"
                description="Only if customer has network coverage"
                class="mb-2"
              >
                <BFormInput
                  id="fMobileNumber"
                  v-model="formInformation.mobile_number"
                  v-mask="'0##########'"
                  :placeholder="isVerified ? '' : 'enter mobile number here'"
                  :state="errors.length > 0 ? false : null"
                  :disabled="state.busy || isVerified"
                />
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="12"
            md="6"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="email"
              name="email"
              rules="email"
            >
              <BFormGroup
                label="Email"
                label-for="fEmail"
                label-class="font-weight-bolder"
                description="Only if customer has an email."
                class="mb-2"
              >
                <BFormInput
                  id="fEmail"
                  v-model="formInformation.email"
                  :placeholder="isVerified ? '' : 'enter email here'"
                  type="email"
                  :state="errors.length > 0 ? false : null"
                  :disabled="state.busy || isVerified"
                />
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="12"
            md="3"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="gender"
              name="gender"
              rules="required"
            >
              <BFormGroup
                label="Gender"
                label-for="fGender"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormSelect
                  id="fGender"
                  v-model="formInformation.gender"
                  :options="options.gender"
                  :state="errors.length > 0 ? false : null"
                  :disabled="state.busy || isVerified"
                >
                  <template #first>
                    <BFormSelectOption
                      value=""
                      disabled
                      v-text="' - - select here - - '"
                    />
                  </template>
                </BFormSelect>
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="6"
            md="3"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="birth_date"
              name="birth date"
              rules="required"
            >
              <BFormGroup
                label="Birth Date"
                label-for="fBirthDate"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <flat-pickr
                  id="fBirthDate"
                  v-model="formInformation.birth_date"
                  placeholder="yyyy/mm/dd"
                  :class="['form-control', {
                    'is-invalid': errors.length > 0
                  }]"
                  :config="{
                    ...flatPickerConfig,
                    altInput: false
                  }"
                  :disabled="state.busy || isVerified"
                />
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="6"
            md="2"
          >
            <BFormGroup
              label="Age"
              label-for="fAge"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fAge"
                v-model="formInformation.age"
                type="number"
                placeholder="0"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            class="py-2"
          >
            <div class="border-bottom" />
          </BCol>
          <!--
          <BCol
            cols="12"
            md="6"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="area"
              name="area"
            >
              <BFormGroup
                label="Area"
                label-for="fArea"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <VSelect
                  v-model="selected.area"
                  input-id="fArea"
                  label="area_name"
                  clearable
                  append-to-body
                  :placeholder="isVerified ? '' : 'select area here'"
                  :options="options.areas"
                  :disabled="[
                    state.busy,
                    fetching.areas,
                    isVerified
                  ].some(isTrue => isTrue)"
                  :loading="fetching.areas"
                  :calculate-position="calculateDropPosition"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  @search="searchAreas"
                >
                  <template #option="{ area_name }">
                    <div
                      class="text-break text-wrap"
                      v-text="area_name"
                    />
                  </template>
                  <template #selected-option="{ area_name }">
                    <div
                      class="w-200px w-lg-325px text-truncate"
                      v-text="area_name"
                    />
                  </template>
                  <template #no-options="">
                    no available area
                  </template>
                </VSelect>
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="12"
            md="6"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="cluster"
              name="cluster"
            >
              <BFormGroup
                label="Cluster"
                label-for="fCluster"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <VSelect
                  v-model="selected.cluster"
                  input-id="fCluster"
                  label="cluster_name"
                  clearable
                  append-to-body
                  :placeholder="isVerified ? '' : 'select cluster here'"
                  :options="options.clusters"
                  :disabled="[
                    state.busy,
                    fetching.clusters,
                    isVerified
                  ].some(isTrue => isTrue)"
                  :loading="fetching.clusters"
                  :calculate-position="calculateDropPosition"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  @search="searchClusters"
                >
                  <template #option="{ cluster_name }">
                    <div
                      class="text-break text-wrap"
                      v-text="cluster_name"
                    />
                  </template>
                  <template #selected-option="{ cluster_name }">
                    <div
                      class="w-200px w-lg-325px text-truncate"
                      v-text="cluster_name"
                    />
                  </template>
                  <template #no-options="">
                    no available cluster
                  </template>
                </VSelect>
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol> -->

          <BCol cols="12" />

          <BCol
            cols="12"
            md="6"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="province"
              name="province"
              rules="required"
            >
              <BFormGroup
                label="Province"
                label-for="fProvince"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <VSelect
                  v-model="selected.province"
                  input-id="fProvince"
                  label="province_name"
                  clearable
                  append-to-body
                  :placeholder="isVerified ? '' : 'select province here'"
                  :options="options.provinces"
                  :disabled="[
                    state.busy,
                    fetching.provinces,
                    isVerified
                  ].some(isTrue => isTrue)"
                  :loading="fetching.provinces"
                  :calculate-position="calculateDropPosition"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  @search="searchProvinces"
                >
                  <template #option="{ province_name, region }">
                    <div
                      class="text-break text-wrap"
                      v-text="province_name"
                    />
                    <div
                      v-if="region"
                      class="text-muted small"
                      v-text="region?.region_name"
                    />
                  </template>
                  <template #selected-option="{ province_name }">
                    <div
                      class="w-200px w-lg-325px text-truncate"
                      v-text="province_name"
                    />
                  </template>
                  <template #no-options="">
                    no available province
                  </template>
                </VSelect>
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="12"
            md="6"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="municipality"
              name="municipality"
              rules="required"
            >
              <BFormGroup
                label="Municipality"
                label-for="fMunicipality"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <VSelect
                  v-model="selected.municipality"
                  input-id="fMunicipality"
                  label="municipality_name"
                  clearable
                  append-to-body
                  :placeholder="isVerified ? '' : 'select municipality here'"
                  :options="options.municipalities"
                  :disabled="[
                    state.busy,
                    fetching.municipalities,
                    fetching.provinces,
                    isVerified
                  ].some(isTrue => isTrue)"
                  :loading="fetching.municipalities"
                  :calculate-position="calculateDropPosition"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  @search="searchMunicipalities"
                >
                  <template #option="{ municipality_name }">
                    <div
                      class="text-break text-wrap"
                      v-text="municipality_name"
                    />
                  </template>
                  <template #selected-option="{ municipality_name }">
                    <div
                      class="w-200px w-lg-325px text-truncate"
                      v-text="municipality_name"
                    />
                  </template>
                  <template #no-options="">
                    no available municipality
                  </template>
                </VSelect>
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="12"
            md="6"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="barangay"
              name="barangay"
              rules="required"
            >
              <BFormGroup
                label="Barangay"
                label-for="fBarangay"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <VSelect
                  v-model="selected.barangay"
                  input-id="fBarangay"
                  label="barangay_name"
                  clearable
                  append-to-body
                  :placeholder="isVerified ? '' : 'select barangay here'"
                  :options="options.barangays"
                  :disabled="[
                    state.busy,
                    fetching.barangays,
                    fetching.municipalities,
                    fetching.provinces,
                    isVerified
                  ].some(isTrue => isTrue)"
                  :loading="fetching.barangays"
                  :calculate-position="calculateDropPosition"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  @search="searchBarangays"
                >
                  <template #option="{ barangay_name }">
                    <div
                      class="text-break text-wrap"
                      v-text="barangay_name"
                    />
                  </template>
                  <template #selected-option="{ barangay_name }">
                    <div
                      class="w-200px w-lg-325px text-truncate"
                      v-text="barangay_name"
                    />
                  </template>
                  <template #no-options="">
                    no available barangay
                  </template>
                </VSelect>
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol cols="12" />

          <BCol
            cols="12"
            md="6"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="address"
              name="address"
              rules="max:1000"
            >
              <BFormGroup
                label="Landmark / Block No. / Street / Zone"
                label-for="fAddress"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <template #label>
                  <span class="d-flex justify-content-between">
                    Landmark / Block No. / Street / Zone
                    <span>
                      {{ formInformation.address ? formInformation.address.length : 0 }} / 1000
                    </span>
                  </span>
                </template>
                <BFormTextarea
                  id="fAddress"
                  v-model="formInformation.address"
                  rows="5"
                  max-rows="12"
                  maxlength="1000"
                  :placeholder="isVerified ? '' : 'enter landmark / block no. / street / zone here'"
                  :state="errors.length > 0 ? false : null"
                  :disabled="state.busy || isVerified"
                  @keydown.enter="preventEnterKey"
                />
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="12"
            md="6"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="remarks"
              name="remarks"
              rules="max:1000"
            >
              <BFormGroup
                label="Other Informations"
                label-for="fRemarks"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <template #label>
                  <span class="d-flex justify-content-between">
                    Other Informations
                    <span>
                      {{ formInformation.remarks ? formInformation.remarks.length : 0 }} / 1000
                    </span>
                  </span>
                </template>
                <BFormTextarea
                  id="fRemarks"
                  v-model="formInformation.remarks"
                  rows="5"
                  max-rows="12"
                  maxlength="1000"
                  :placeholder="isVerified ? '' : 'enter other informations here'"
                  :state="errors.length > 0 ? false : null"
                  :disabled="state.busy || isVerified"
                />
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="12"
            class="py-2"
          >
            <div class="border-bottom" />
          </BCol>

          <BCol
            cols="6"
            md="2"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="is_blo"
              name="is blo"
              rules="required"
            >
              <BFormGroup
                label="Big Land Owner?"
                label-for="fIsBigLandOwner"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormSelect
                  id="fIsBigLandOwner"
                  v-model="formInformation.is_blo"
                  :options="options.yesOrNos"
                  :state="errors.length > 0 ? false : null"
                  :disabled="state.busy || isVerified"
                >
                  <template #first>
                    <BFormSelectOption
                      value=""
                      disabled
                      v-text="' - - select here - - '"
                    />
                  </template>
                </BFormSelect>
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="6"
            md="2"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="is_financier"
              name="is financier"
              rules="required"
            >
              <BFormGroup
                label="Financier?"
                label-for="fIsFinancier"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormSelect
                  id="fIsFinancier"
                  v-model="formInformation.is_financier"
                  :options="options.yesOrNos"
                  :state="errors.length > 0 ? false : null"
                  :disabled="state.busy || isVerified"
                >
                  <template #first>
                    <BFormSelectOption
                      value=""
                      disabled
                      v-text="' - - select here - - '"
                    />
                  </template>
                </BFormSelect>
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="6"
            md="2"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="is_mango_contractor"
              name="is mango contractor"
              rules="required"
            >
              <BFormGroup
                label="Mango Contractor?"
                label-for="fIsMangoContractor"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormSelect
                  id="fIsMangoContractor"
                  v-model="formInformation.is_mango_contractor"
                  :options="options.yesOrNos"
                  :state="errors.length > 0 ? false : null"
                  :disabled="state.busy || isVerified"
                >
                  <template #first>
                    <BFormSelectOption
                      value=""
                      disabled
                      v-text="' - - select here - - '"
                    />
                  </template>
                </BFormSelect>
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="6"
            md="2"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="is_trader"
              name="is trader"
              rules="required"
            >
              <BFormGroup
                label="Trader?"
                label-for="fIsTrader"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormSelect
                  id="fIsTrader"
                  v-model="formInformation.is_trader"
                  :options="options.yesOrNos"
                  :state="errors.length > 0 ? false : null"
                  :disabled="state.busy || isVerified"
                >
                  <template #first>
                    <BFormSelectOption
                      value=""
                      disabled
                      v-text="' - - select here - - '"
                    />
                  </template>
                </BFormSelect>
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>

          <BCol
            cols="6"
            md="2"
          >
            <ValidationProvider
              v-slot="{ errors }"
              vid="is_aljay"
              name="is aljay"
              rules="required"
            >
              <BFormGroup
                label="Aljay Product User?"
                label-for="fIsAljayProductUser"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormSelect
                  id="fIsAljayProductUser"
                  v-model="formInformation.is_aljay"
                  :options="options.yesOrNos"
                  :state="errors.length > 0 ? false : null"
                  :disabled="state.busy || isVerified"
                >
                  <template #first>
                    <BFormSelectOption
                      value=""
                      disabled
                      v-text="' - - select here - - '"
                    />
                  </template>
                </BFormSelect>
                <div
                  v-if="(errors.length > 0)"
                  class="invalid-feedback"
                  v-text="errors[0]"
                />
              </BFormGroup>
            </ValidationProvider>
          </BCol>
        </BRow>
      </form>
    </ValidationObserver>
  </BContainer>
</template>
<script>
import QUERY from 'lodash'
import { mapGetters } from 'vuex'

import MxMisc from '@/mixins/misc'
import MProvinces from '@/mixins/locations/provinces'
import MMunicipalities from '@/mixins/locations/municipalities'
import MBarangays from '@/mixins/locations/barangays'

import { SAdminCustomer } from '@/services/admin'

// import MAreas from '@/mixins/locations/areas'
// import MClusters from '@/mixins/locations/clusters'

export default {
  name: 'VFSOCustomerInformations',

  mixins: [
    // MAreas,
    // MClusters,
    MProvinces,
    MMunicipalities,
    MBarangays,
    MxMisc
  ],

  emits: ['updated'],

  data () {
    return {
      flatPickerConfig: {
        appendTo: document.body,
        altInput: true,
        allowInput: true,
        disableMobile: true,
        dateFormat: 'Y-m-d'
      },
      state: {
        busy: false,
        editing: false
      },
      selected: {
        tagging: 1
      },
      fetching: {
        gender: false
      },
      options: {
        gender: ['Male', 'Female'],
        yesOrNos: [
          {
            text: 'No',
            value: '0'
          },
          {
            text: 'Yes',
            value: '1'
          }
        ]
      },
      formInformation: {
        id: '',
        area_id: '',
        cluster_id: '',
        province_id: '',
        municipality_id: '',
        barangay_id: '',
        first_name: '',
        middle_name: '',
        last_name: '',
        suffix_name: '',
        email: '',
        mobile_number: '',
        birth_date: '',
        age: '',
        gender: '',
        address: '',
        remarks: '',
        status: 'New',
        is_blo: 0,
        is_financier: 0,
        is_mango_contractor: 0,
        is_trader: 0,
        is_aljay: 0,
        active: 1
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    }),

    isVerified () {
      return this.formInformation.status === 'Verified'
    }
  },

  watch: {
    // 'selected.area' (area) {
    //   this.formInformation.area_id = area?.id || ''
    // },
    // 'selected.cluster' (cluster) {
    //   this.formInformation.cluster_id = cluster?.id || ''
    // },
    'selected.province' (province) {
      this.formInformation.province_id = province?.id || ''
    },

    'selected.municipality' (municipality) {
      this.formInformation.municipality_id = municipality?.id || ''
    },

    'selected.barangay' (barangay) {
      this.formInformation.barangay_id = barangay?.id || ''
    },

    'formInformation.birth_date' (birthDate) {
      this.formInformation.age = this.calculateAge(birthDate)
    }
  },

  methods: {

    isFetchingLocations () {
      return this.fetching.provinces || this.fetching.municipalities || this.fetching.barangays
    },

    setInformation (customer) {
      this.formInformation = Object.assign(this.formInformation, customer)
    },

    getInformation () {
      return this.formInformation
    },

    async showInformation (customerID) {
      return await SAdminCustomer.show(customerID).then(
        ({ data: { customer } }) => customer
      )
    },

    async createInformation () {
      this.state.editing = false

      this.editable.cluster = this.currentUser.cluster
      this.editable.municipality = ''
      this.editable.barangay = ''

      this.formInformation = Object.assign(this.formInformation, {
        id: '',
        area_id: '',
        cluster_id: '',
        province_id: '',
        municipality_id: '',
        barangay_id: '',
        first_name: '',
        middle_name: '',
        last_name: '',
        suffix_name: '',
        email: '',
        mobile_number: '',
        birth_date: '',
        age: '',
        gender: '',
        address: '',
        remarks: '',
        status: 'New',
        is_blo: 0,
        is_financier: 0,
        is_mango_contractor: 0,
        is_trader: 0,
        is_aljay: 0,
        active: 1
      })

      this.getProvinces(this)

      // this.getAreas(this).finally(() => {
      //   this.selected.area = QUERY.find(this.options.areas, {
      //     id: this.currentUser.area
      //   }) || ''
      // })
    },

    async editInformation (customerInformation) {
      this.state.editing = true

      // this.editable.cluster = customerInformation.cluster_id
      this.editable.municipality = customerInformation.municipality_id
      this.editable.barangay = customerInformation.barangay_id

      this.formInformation = Object.assign(this.formInformation, {
        id: customerInformation.id,
        first_name: customerInformation.first_name,
        middle_name: customerInformation.middle_name,
        last_name: customerInformation.last_name,
        suffix_name: customerInformation.suffix_name,
        email: customerInformation.email,
        mobile_number: customerInformation.mobile_number,
        birth_date: customerInformation.birth_date,
        age: this.calculateAge(customerInformation.birth_date),
        gender: customerInformation.gender,
        address: customerInformation.address,
        remarks: customerInformation?.remarks || '',
        active: customerInformation.active,
        is_blo: customerInformation.is_blo,
        is_financier: customerInformation.is_financier || 0,
        is_mango_contractor: customerInformation.is_mango_contractor || 0,
        is_trader: customerInformation.is_trader || 0,
        is_aljay: customerInformation.is_aljay,
        status: customerInformation.status
      })

      // this.getAreas(this).finally(() => {
      //   this.selected.area = QUERY.find(this.options.areas, {
      //     id: customerInformation.area_id
      //   }) || ''
      // })

      await this.getProvinces(this).finally(
        () => {
          this.selected.province = QUERY.find(this.options.provinces, {
            id: customerInformation.province_id
          }) || ''
        }
      )
    },

    async validateInformation () {
      return new Promise((resolve, reject) => {
        this.$refs.formInformation.validate().then(
          isFormValid => {
            if (isFormValid) {
              return resolve(isFormValid)
            }

            return reject(new Error('Invalid Form'))
          }
        )
      })
    },

    async submitInformation () {
      return new Promise(resolve => {
        this.validateInformation().then(
          () => {
            this.swalConfirm({
              html: this.state.editing ? 'Update this Customer?' : 'Register this Customer?',
              confirmButtonText: this.state.editing ? 'Update' : 'Register',
              cancelButtonText: 'Discard',
              preConfirm: async () => {
                this.state.busy = true

                const createOrUpdate = () => {
                  return this.state.editing ? this.putInformation() : this.postInformation()
                }

                return createOrUpdate().catch(
                  ({ message }) => {
                    if (message && message?.errors) {
                      this.$refs.formInformation.setErrors(message?.errors)
                    }
                  }
                ).finally(() => {
                  this.state.busy = false
                })
              }
            }).then(resolve)
          }
        ).catch(() => {
          this.swalInvalid()
        })
      })
    },

    async postInformation () {
      return await SAdminCustomer.post(this.formInformation).then(
        ({ data }) => data
      )
    },

    async putInformation () {
      return await SAdminCustomer.put(this.formInformation).then(
        ({ data }) => data
      )
    },

    setErrors (errors) {
      if (errors) {
        this.$refs.formInformation.setErrors(errors)
      }
    }
  }
}
</script>
